import * as React from "react";

interface IItemValueProps {
  value: string | React.ReactNode | null;
}
export const ItemValue = (props: IItemValueProps) => (
  <div className={`form-control form-control--readonly`}>{props.value || "-"}</div>
);
